<template>
  <div class="blocoCEP flex flex-col">
    <!--  START HEADER NOVA COTACAO INVOICE -->
    <div class="flex-grow container">
      <!--  END HEADER  NOVA COTACAO INVOICE -->
      <div class="flex justify-center items-center flex-col">
        <div class="cardAzulCEP rounded-t-lg p-3 w-full lg:w-1/2 shadow-lg">
          <div class="text-white pb-5 textoLight">
            <span>Olá, antes de continuar precisamos de alguns dados:</span>
          </div>
          <div
            class="w-full flex justify-between items-center"
            :class="borderCep"
            v-if="!semCEP"
          >
            <div class="w-2/3">
              <vs-input
                style="background-color: transparent"
                class="text-white"
                size="default"
                name="Cep"
                id="Cep"
                @keyup.native="keyMonitorCEP"
                v-model="cep"
                v-validate="{ required: true, min: 10 }"
                placeholder="Digite seu CEP"
                v-mask="'##.###-###'"
              />
            </div>
            <div
              class="textoSemCEP flex items-center justify-end text-white w-1/3 ml-3 gap-2"
            >
              <small for="semCEP" class="">Não sei o meu CEP</small>
              <vs-switch id="semCEP" color="success" v-model="semCEP" />
            </div>
          </div>
          <div class="text-white" v-if="semCEP">
            <div :class="borderEstado">
              <label for="Estado" class="font-light text-lg"
                >Selecione o Estado</label
              >
              <v-select
                :options="estados"
                name="Estado"
                id="Estado"
                autocomplete="off"
                @input="
                  buscaDadosSelectsCidades(
                    'domMunicipio',
                    'cidades',
                    'nomeCidade',
                    'idCidade',
                  )
                "
                v-validate="{ required: true }"
                v-model="estado"
                label="label"
              ></v-select>
            </div>
            <div class="pt-5" :class="borderCidade">
              <label for="cidade" class="font-light text-lg"
                >Selecione a Cidade</label
              >
              <v-select
                :options="cidades"
                name="Cidade"
                id="Cidade"
                v-model="formEndereco.cidade"
                label="label"
                v-validate="{ required: true }"
              ></v-select>
            </div>
          </div>
          <div class="pt-5">
            <label class="text-white textoLight"
              >Qual o tipo do atendimento que você quer?</label
            >
            <ul class="leftx flex gap-3 pt-5">
              <div
                :class="
                  tipoAtendimento === 'Digital'
                    ? 'opcaoSelecionada'
                    : 'opcaoNaoSelecionada'
                "
                class="p-2 rounded-lg flex items-center justify-center textoLight"
              >
                <li class="flex items-center justify-center">
                  <vs-radio
                    v-model="tipoAtendimento"
                    vs-name="radios1"
                    vs-value="Digital"
                    >Digital</vs-radio
                  >
                </li>
              </div>
              <div
                :class="
                  tipoAtendimento === 'Humanizado'
                    ? 'opcaoSelecionada'
                    : 'opcaoNaoSelecionada'
                "
                class="p-2 rounded-lg flex items-center justify-center textoLight"
              >
                <li class="flex items-center justify-center">
                  <vs-radio
                    v-model="tipoAtendimento"
                    vs-name="radios2"
                    vs-value="Humanizado"
                    @change="returnLinkWhats2()"
                    >Humanizado</vs-radio
                  >
                </li>
              </div>
            </ul>
          </div>
        </div>
        <button
          @click="submitForm"
          class="botaoContinuar p-5 rounded-b-lg w-full flex justify-between lg:w-1/2"
        >
          <div class="text-white text-xl flex items-center">
            <span>Continuar</span>
          </div>
          <div class="flex items-center">
            <img
              src="../../assets/images/svg/icon-arrow-right.svg"
              alt="Seta para a direita"
            />
          </div>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import service from '../../services';
import vSelect from 'vue-select';

export default {
  data() {
    return {
      tipoAtendimento: 'Digital',
      cep: null,
      semCEP: false,
      estados: [],
      estado: null,
      cidades: [],
      cidade: null,
      borderCep: 'border-white',
      borderEstado: 'border-white',
      borderCidade: 'border-white',
      formEndereco: {
        cep: null,
        endereco: null,
        numero: null,
        complemento: null,
        bairro: null,
        cidade: null,
        estado: null,
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    keyMonitorCEP: function () {
      if (this.cep.length == 10) {
        this.$vs.loading();
        const cepbusca = this.cep.replace('.', '').replace('-', '');
        service
          .post('g', 'BuscaCEP', {
            cep: cepbusca,
          })
          .then((res) => {
            this.formEndereco.cep = this.cep;
            this.formEndereco.endereco = res.data.street;
            this.formEndereco.bairro = res.data.neighborhood;
            this.formEndereco.cidade = res.data.city;
            this.formEndereco.estado = res.data.state;
            this.$vs.loading.close();
          })
          .catch(() => {
            this.$vs.loading.close();
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Não foi possível encontrar o CEP, informe o restante do endereço manualmente ou confira o CEP.',
              color: 'danger',
            });
          });
      }
    },
    submitForm() {
      this.borderCep = 'border-white';
      this.borderCidade = 'border-white';
      this.borderEstado = 'border-white';
      this.formEndereco.tipoAtendimento = this.tipoAtendimento;
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.semCEP) {
            this.formEndereco.cep = null;
            this.formEndereco.bairro = null;
            this.formEndereco.endereco = null;
            this.formEndereco.cidade = this.formEndereco.cidade.label;
            this.formEndereco.estado = this.estado.label;
          }

          if (this.formEndereco.cep)
            localStorage.setItem('cep', this.formEndereco.cep);
          if (this.formEndereco.bairro)
            localStorage.setItem('bairro', this.formEndereco.bairro);
          if (this.formEndereco.endereco)
            localStorage.setItem('endereco', this.formEndereco.endereco);
          if (this.formEndereco.cidade)
            localStorage.setItem('cidade', this.formEndereco.cidade);
          if (this.formEndereco.estado)
            localStorage.setItem('estado', this.formEndereco.estado);
          if (this.formEndereco.tipoAtendimento)
            localStorage.setItem(
              'tipoAtendimento',
              this.formEndereco.tipoAtendimento,
            );

          this.$emit('cepSalvo', true);
        } else {
          if (!this.cep || this.cep.length < 10) {
            this.borderCep = 'border-red';
          }

          if (!this.estado) {
            this.borderEstado = 'border-red';
          }

          if (
            !this.formEndereco.cidade ||
            this.formEndereco.cidade.length < 1
          ) {
            this.borderCidade = 'border-red';
          }

          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Existem campos não preenchidos',
            color: 'danger',
          });
        }
      });
    },
    buscaDadosSelects(model, array, campoDescricao, campoPK) {
      service.getAll('g', {}, `${model}/list/`).then((res) => {
        res.data.forEach((element) => {
          this[array].push({
            id: element[campoPK],
            label: element[campoDescricao],
          });
        });

        this[array].sort(function (a, b) {
          return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
        });
        this[array].unshift({ id: null, label: 'Selecione' });
      });
    },
    buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      if (!this.estado) {
        this[array] = [];
        this.cidade = null;
        return;
      }

      this.$vs.loading();
      this[array] = [];
      if (this.estado && this.estado.id) {
        this.$vs.loading();

        service
          .getAll('g', {}, `${model}/list/codUf/${this.estado.id}`)
          .then((res) => {
            if (res)
              res.data.forEach((element) => {
                this[array].push({
                  id: element[campoPK],
                  label: element[campoDescricao],
                });
              });

            this.$vs.loading.close();
          });
      }
    },
    returnLinkWhats2(nome, celular) {
      console.log(309, 'entrou aqui');
      nome = '';
      celular = '31992636483';

      let texto = `Olá, tudo bem? \nGostaria de gerar uma proposta.`;
      let textoEncode = encodeURI(texto);

      let link = '';
      link = `https://api.whatsapp.com/send?phone=55${celular}&text=${textoEncode}`;

      window.open(link, '_blank');
    },
  },
  created() {
    this.buscaDadosSelects('domUf', 'estados', 'nomeUf', 'codUf');
  },
  mounted() {},
  components: { 'v-select': vSelect },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Product+Sans&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');
.blocoCEP {
  position: fixed;
  padding-top: 100px;
  z-index: 9;
  height: 100vh;
  width: 100vw;
  background-color: rgba(255, 255, 255, 0.8);
  .textoSemCEP {
    font-size: 0.9rem;
  }
  .linhaDivisora {
    color: #ffffff;
  }
  .vs-input--placeholder {
    background: #078fcf !important;
    color: white !important;
    font-size: 1rem;
  }
  .vs-con-input .vs-inputx {
    font-size: 1rem;
    font-weight: 300;
    border: none !important;
    background-color: transparent;
  }
  .vs-input-primary .vs-input--input:focus {
    border: none !important;
    box-shadow: none !important;
    color: #ffffff;
  }
  .vs--searchable .vs__dropdown-toggle {
    border: none !important;
  }
  .vs--single .vs__selected {
    color: white;
  }
  .feather {
    color: white;
  }
  .opcaoSelecionada {
    background-color: #ffffff;
    color: #078fcf;
  }
  .opcaoNaoSelecionada {
    background-color: #93c8ff;
    color: #078fcf;
  }
  .botaoContinuar {
    background: #03c144;
    font-weight: 700;
    border: 0;
  }
  .inputCep {
    background-color: transparent;
  }
}

.textoLight {
  font-weight: lighter;
  line-height: 26px;
}

.border-red {
  border-bottom: 1px solid orange;
}
.border-white {
  border-bottom: 1px solid #fff;
}
.footerColetaEstado {
  flex-shrink: 0;
}
.cardAzulCEP {
  background: #078fcf;
}
</style>
